// src/context/EventsContext.js
import { createContext, useContext, useState, useCallback } from "react";
import { fetchEvents } from "../api/eventsApi";

const EventsContext = createContext();

export function EventsProvider({ children }) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadEvents = useCallback(async (from, to) => {
    setLoading(true);
    try {
      const data = await fetchEvents(from, to);
      setEvents(data);
    } catch (err) {
      // Silent fail
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <EventsContext.Provider value={{ events, loading, loadEvents }}>
      {children}
    </EventsContext.Provider>
  );
}

export function useEvents() {
  return useContext(EventsContext);
}
